import React from 'react';
import { compose } from 'redux';

import { CONSTRAINT_TYPES } from 'dpl/util/validation/constraints';
import withFormCapabilities from 'dpl/form/decorators/withFormCapabilities';
import withCurrentUser from 'dpl/decorators/withCurrentUser';
import LoginForm from 'dpl/components/LoginForm';
import postLoginRedirect from 'dpl/util/postLoginRedirect';
import { SIGNUP_FORM_TYPES, USER_TYPES } from 'dpl/constants/shared';
import { get } from 'dpl/util/object';

function LoginFormContainer(props) {
  return <LoginForm { ...props } />;
}

export default compose(
  withCurrentUser,
  // we don't want formState to ever update here, bc the server never returns
  // the value the user entered
  withFormCapabilities(() => null, {
    mapPropsAndStateToValidationSchema: () => ({
      email: CONSTRAINT_TYPES.EMAIL,
      password: CONSTRAINT_TYPES.PASSWORD
    }),
    onSubmit: (props, formStateForSubmission) => {
      const {
        login,
        onAuth
      } = props;

      return login({ user: formStateForSubmission })
        .then((json) => {
          if (onAuth) {
            return onAuth(json);
          }

          if (get(json, 'data.data.buyer')) {
            return postLoginRedirect(USER_TYPES.BUYER);
          }

          return postLoginRedirect(USER_TYPES.BREEDER);
        });
    },
    submitWithErrors: false
  })
)(LoginFormContainer);
